import React from 'react';
export var ListItem = function ListItem(props) {
  var forgeDoc = props.forgeDoc,
    render = props.render;
  return /*#__PURE__*/React.createElement("li", {
    key: forgeDoc.key,
    children: forgeDoc.children.map(render)
  });
};